const isDebug = import.meta.env.MODE !== 'production';

export default isDebug;